<template>
  <v-app :theme="themeName" class="application">
    <router-view v-slot="{ Component }">
      <Suspense>
        <component :is="Component" v-if="Component" />

        <SfiAppLoading v-else :title="title" />
      </Suspense>
    </router-view>
  </v-app>
</template>

<script setup lang="ts">
import { useTheme } from '@simplifi/components'

const { themeName } = useTheme()

const title = import.meta.env.VITE_APP_TITLE
</script>
